import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const WorkingHoursPanel = ({ workingHours, onWorkingHoursChange }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const handleTimeChange = (dayType, field, value) => {
    onWorkingHoursChange({
      ...workingHours,
      [dayType]: {
        ...workingHours?.[dayType],
        [field]: value
      }
    });
  };

  return (
    <div className="bg-white rounded-2xl shadow-lg border border-slate-200 overflow-hidden">
      {/* Header */}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full flex items-center justify-between p-6 hover:bg-slate-50 transition-colors duration-200"
      >
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary">
            <Icon name="Clock" size={20} className="text-white" />
          </div>
          <div className="text-right">
            <h3 className="text-lg font-bold text-slate-900">ساعات العمل</h3>
            <p className="text-sm text-slate-600">تحديد أوقات التوفر</p>
          </div>
        </div>
        <Icon 
          name={isExpanded ? "ChevronUp" : "ChevronDown"} 
          size={20} 
          className="text-slate-600" 
        />
      </button>
      {/* Content */}
      {isExpanded && (
        <div className="p-6 pt-0 space-y-6">
          {/* Weekday Hours */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <div className="w-1 h-6 bg-gradient-to-b from-blue-500 to-blue-400 rounded-full"></div>
              <h4 className="font-semibold text-slate-900">أيام الأسبوع</h4>
            </div>
            
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">
                  بداية العمل
                </label>
                <Input
                  type="time"
                  value={workingHours?.weekday?.start || ''}
                  onChange={(e) => handleTimeChange('weekday', 'start', e?.target?.value)}
                  className="w-full"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">
                  نهاية العمل
                </label>
                <Input
                  type="time"
                  value={workingHours?.weekday?.end || ''}
                  onChange={(e) => handleTimeChange('weekday', 'end', e?.target?.value)}
                  className="w-full"
                />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">
                  بداية الاستراحة
                </label>
                <Input
                  type="time"
                  value={workingHours?.weekday?.breakStart || ''}
                  onChange={(e) => handleTimeChange('weekday', 'breakStart', e?.target?.value)}
                  className="w-full"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">
                  نهاية الاستراحة
                </label>
                <Input
                  type="time"
                  value={workingHours?.weekday?.breakEnd || ''}
                  onChange={(e) => handleTimeChange('weekday', 'breakEnd', e?.target?.value)}
                  className="w-full"
                />
              </div>
            </div>
          </div>

          {/* Divider */}
          <div className="border-t border-slate-200"></div>

          {/* Weekend Hours */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <div className="w-1 h-6 bg-gradient-to-b from-blue-500 to-cyan-500 rounded-full"></div>
              <h4 className="font-semibold text-slate-900">عطلة نهاية الأسبوع</h4>
            </div>
            
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">
                  بداية العمل
                </label>
                <Input
                  type="time"
                  value={workingHours?.weekend?.start || ''}
                  onChange={(e) => handleTimeChange('weekend', 'start', e?.target?.value)}
                  className="w-full"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">
                  نهاية العمل
                </label>
                <Input
                  type="time"
                  value={workingHours?.weekend?.end || ''}
                  onChange={(e) => handleTimeChange('weekend', 'end', e?.target?.value)}
                  className="w-full"
                />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">
                  بداية الاستراحة
                </label>
                <Input
                  type="time"
                  value={workingHours?.weekend?.breakStart || ''}
                  onChange={(e) => handleTimeChange('weekend', 'breakStart', e?.target?.value)}
                  className="w-full"
                  placeholder="اختياري"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">
                  نهاية الاستراحة
                </label>
                <Input
                  type="time"
                  value={workingHours?.weekend?.breakEnd || ''}
                  onChange={(e) => handleTimeChange('weekend', 'breakEnd', e?.target?.value)}
                  className="w-full"
                  placeholder="اختياري"
                />
              </div>
            </div>
          </div>

          {/* Info Box */}
          <div className="bg-gradient-to-r from-blue-50 to-blue-100 rounded-lg p-4 border border-blue-200">
            <div className="flex items-start gap-3">
              <Icon name="Info" size={20} className="text-indigo-600 mt-0.5" />
              <p className="text-sm text-indigo-900">
                سيتم تطبيق هذه الأوقات على جميع الأيام المتاحة. يمكنك حجب أيام محددة من القسم أدناه.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WorkingHoursPanel;